import './ProfileTable.scss';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../loader/Loader';
import config from '../../js/config/_global';
import { userStore } from '../../store';
import DealershipList from '../dealershipList/DealershipList';
import DealershipGroupsList from '../dealershipGroupsList/DealershipGroupsList';
import { BRAND_NAMES } from '../../js/_constants';

const ProfileTable = () => {
    const { t } = useTranslation();
    const { details, loading, dealershipGroups, dealerships } = userStore();
    const [brandTextArray, setBrandTextArray] = useState([t('no_brand_assigned')] as string[]);
    const [classBrand, setClassBrand] = useState('no-brand');

    // logic for set brand text
    useEffect(() => {
        const arrayText = [] as string[];

        if (details.userGrantedBrands.length === 0 || !details.brands ) {
            return;
        }

        // no red/alert color | we got a brand
        setClassBrand('');

        // set string for each brand (brand name)
        details.userGrantedBrands.forEach(singleBrandLetter => arrayText.push(BRAND_NAMES[singleBrandLetter]));
    
        setBrandTextArray(arrayText)
    }, [details.brands, details.userGrantedBrands]);

    return (
        <div className="b-profile-table">
            {loading ? (
                <Loader loading={loading} />
            ) : (
                <>
                    <h4>{t('profile_userprofile')}</h4>
                    <div className="profile-data">
                        <div className="labeled-field">
                            <p className="label">{t('profile_language')}</p>
                            <p className="field" data-testid="profile-language">{details?.language || t('profile_default_language')}</p>
                        </div>
                        <div className="labeled-field">
                            <p className="label">{t('profile_username')}</p>
                            <p className="field" data-testid="profile-username">{details?.username}</p>
                        </div>
                        <div className="labeled-field">
                            <p className="label">{t('profile_email')}</p>
                            <p className="field" data-testid="profile-email">{details?.email}</p>
                        </div>
                        <div className="labeled-field">
                            <p className="label">{t('profile_market')}</p>
                            {details?.affiliatedCountries.length === 0
                                ? <p className="field no-market">{t('no_market_assigned')}</p>
                                : <p className="field" data-testid="profile-markets">{details?.affiliatedCountries.map(country => country.name).join(', ')}</p>
                            }
                        </div>

                        <div className="labeled-field">
                            <p className="label">
                                {t('profile_brands')}
                            </p>
                            {brandTextArray.map((item, index) => (
                                <p
                                    className={`field ${classBrand}`}
                                    key={index}
                                    data-testid="profile-brands"
                                >
                                    {item}
                                </p>
                            ))}
                        </div>

                    </div>
                    <h4>{t('dealership_groups')}</h4>
                    <div className="profile-data">
                        <div className="labeled-field">
                            <DealershipGroupsList
                                groups={dealershipGroups}
                            />
                        </div>
                    </div>
                    <h4>{t('profile_locations')}</h4>
                    <div className="profile-data">
                        <div className="labeled-field">
                            <DealershipList
                                onClick={() => null}
                            />
                        </div>
                    </div>
                    <h4>{t('profile_personal_data')}</h4>
                    <div className="profile-data">
                        <div className="labeled-field">
                            <p className="label">{t('profile_first_name')}</p>
                            <p className="field" data-testid="profile-first-name">{details?.givenName}</p>
                        </div>
                        <div className="labeled-field">
                            <p className="label">{t('profile_last_name')}</p>
                            <p className="field" data-testid="profile-last-name">{details?.familyName}</p>
                        </div>
                    </div>
                    <p className="change-promt">
                        Retail Content Manager {config.version}
                        <br />
                        <br />
                        {t('profile_change_promt')}
                    </p>
                </>
            )}
        </div>
    );
};

export default ProfileTable;
